/**
 * Monaco Editor 配置
 * 使用 CDN 加载 monaco-editor（避免本地打包导致 OOM）
 */
import { loader } from '@monaco-editor/react';

// 使用 unpkg CDN（比 jsdelivr 更稳定）
loader.config({
  paths: {
    vs: 'https://unpkg.com/monaco-editor@0.55.1/min/vs',
  },
});

// 备选 CDN（如果 unpkg 也不稳定）：
// loader.config({
//   paths: {
//     vs: 'https://cdn.bootcdn.net/ajax/libs/monaco-editor/0.55.1/min/vs'
//   }
// });

export {};
